module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.6-create-page.b637f0fa.png";